import React, { useEffect, useState } from 'react';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import { SecuredConfig } from '@components/security/securedDecoration';
import { InputText } from 'primereact/inputtext';
import SvgTagEdit from '@components/ringil3/icons/TagEdit.tsx';
import { isNotBlank } from '@utils/utils.tsx';
import { KeyFilterType } from 'primereact/keyfilter';
import { FieldLabel } from '@components/framework/formfield/FieldLabel.tsx';

interface ComponentProps {
  secured?: SecuredConfig;
  label: string;
  value: string;
  onChange: (value: string) => void;
  keyfilter?: KeyFilterType;
  icon?: React.ReactElement;
  readOnly?: boolean;
  required?: boolean;
  errorMessage?: string;
  dataTestId?: string;
  dataTestIdInput?: string;
  dataTestIdSave?: string;
  dataTestIdClose?: string;
}

const InputTextTag: React.FC<ComponentProps> = ({
  secured,
  label,
  value,
  onChange,
  keyfilter,
  icon,
  readOnly,
  required = false,
  errorMessage,
  dataTestId,
  dataTestIdInput,
  dataTestIdSave,
  dataTestIdClose,
}) => {
  const [internalValue, setInternalValue] = useState(value);

  useEffect(() => setInternalValue(value), [value]);

  const pane = () => {
    return (
      <div className="flex flex-col gap-1">
        {label && <FieldLabel label={label} />}
        <InputText value={internalValue} onChange={e => setInternalValue(e.target.value)} keyfilter={keyfilter} data-testid={dataTestIdInput} />
      </div>
    );
  };

  return (
    <>
      <ButtonTag
        secured={secured}
        label={label}
        icon={icon}
        value={internalValue}
        actionIcon={<SvgTagEdit />}
        actionPane={pane()}
        onSave={onSuccess => {
          onChange(isNotBlank(internalValue) ? internalValue : null);
          onSuccess();
        }}
        readonly={readOnly}
        required={required}
        errorMessage={errorMessage}
        autoClose
        dataTestId={dataTestId}
        dataTestIdSave={dataTestIdSave}
        dataTestIdClose={dataTestIdClose}
      />
    </>
  );
};

export default InputTextTag;
